import L from 'leaflet';
import 'leaflet-wms-header';
import { toString, isEmpty } from 'lodash';
import btoaMethod from 'btoa';

import * as layerOps from '../../api/Layers/layer-operations';
import * as styleOps from '../../api/Styles/style-operations';

import adaptURL from '../adapt-url';

/**
 * Builds the WMS layer for the map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.layer - The layer object.
 * @param {object} arg.style - The style object.
 * @param {number} [arg.zIndex=10] - The zIndex for the layer.
 * @returns {object} The leaflet layer to add to the map.
 */
const buildWMSLayer = ({ layer, style, zIndex = 10 }) => {
  const wmsOptions = {
    styles: layerOps.getWMSLayerStyle(layer),
    layers: layerOps.getWMSLayerNames(layer),
    format: 'image/png',
    uppercase: true,
    version: layerOps.getWMSVersion(layer),
    transparent: true,
    continuousWorld: true,
    tiled: isEmpty(styleOps.getSLD(style)),
    info_format: 'text/html',
    opacity: styleOps.getRasterOpacityPercentage(style) / 100,
    maxZoom: layerOps.getMaxZoom(layer),
    pane: toString(zIndex),
    attribution: layerOps.getAttribution(layer)
  };
  if (!isEmpty(styleOps.getSLD(style))) wmsOptions.SLD = adaptURL(styleOps.getSLD(style));

  let wmsLayer = {};
  if (isEmpty(layerOps.getUser(layer)) || isEmpty(layerOps.getPassword(layer))) {
    wmsLayer = L.tileLayer.wms(layerOps.getURL(layer), wmsOptions);
  } else {
    const authToken = btoaMethod(`${layerOps.getUser(layer)}:${layerOps.getPassword(layer)}`);
    const wmsHeaders = [
      { header: 'Authorization', value: `Basic ${authToken}` },
      { header: 'content-type', value: 'text/plain' }
    ];
    wmsLayer = L.TileLayer.wmsHeader(`${layerOps.getURL(layer)}?`, wmsOptions, wmsHeaders);
  }

  if (!isEmpty(styleOps.getSLD(style))) delete wmsLayer.wmsParams.layers;

  return wmsLayer;
};

export default buildWMSLayer;
